<template>
    <tr @click="recordSelected">
        <td style="padding: 0 6px">{{ markRecord.count }}</td>
        
        <td class="pt-1" style="padding: 0 6px">
            {{ markRecord.name }}
        </td> 

        <td  style="padding: 0 6px">
            <v-text-field
                v-model="markRecord.course_mark"
                outlined
                dense
                :filled="disableCourseMark"
                :disabled="disableCourseMark"
                hide-details
                type="number"                
                @blur="recordChanged"                
            >                
            </v-text-field>
        </td>

        <td  style="padding: 0 6px">
            <v-text-field
                v-model="markRecord.exam_mark"
                outlined
                dense
                hide-details
                type="number"
                @blur="recordChanged"
                :filled="disableExamMark"
                :disabled="disableExamMark"
            ></v-text-field>
        </td>

         <td  style="padding: 0 6px">
           <v-select
                v-model="markRecord.app1"                
                :items="grades"
                item-value="grade"
                outlined
                dense
                hide-details
                @change="recordChanged"                
            >
                <template v-slot:selection="{item}">
                    {{ item.grade }}
                </template>

                <template
                    v-slot:item=data
                > 
                    {{ data.item.grade }} {{ data.item.description }}
                </template> 

            </v-select>
        </td>

         <td  style="padding: 0 6px">
           <v-select
                v-model="markRecord.con1"                
                :items="grades"
                item-value="grade"
                outlined
                dense
                hide-details
                @change="recordChanged"                
            >
                <template v-slot:selection="{item}">
                    {{ item.grade }}
                </template>

                <template
                    v-slot:item=data
                > 
                    {{ data.item.grade }} {{ data.item.description }}
                </template> 

            </v-select>
        </td>
        
        <td  style="padding: 0 6px">
           <v-select
                v-model="codedComment"                
                :items="comments1"
                item-value="id"
                outlined
                dense
                hide-details
                return-object                
                @change="recordChanged"                
            >
                <template v-slot:selection="{item}">
                    {{ item.id }}
                </template>

                <template
                    v-slot:item=data
                > 
                    {{ data.item.id}} {{ data.item.comment }}
                </template> 

            </v-select>
        </td>

        <td style="padding: 0 6px"> 
            <v-select
                v-model="codedComment1"                
                :items="comments2"
                item-value="id"
                outlined
                dense
                hide-details
                return-object                
                @change="recordChanged"                
            >
                <template v-slot:selection="{item}">
                    {{ item.id }}
                </template>

                <template
                    v-slot:item=data
                > 
                    {{ data.item.id}} {{ data.item.comment }}
                </template>
            </v-select>
        </td>

        <td style="padding: 0 6px">
            <v-tooltip 
                bottom
                
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="green"                        
                        v-bind="attrs"
                        v-on="on"
                        v-show="saved"
                        class="mr-2"
                    >
                        mdi-check-all
                    </v-icon>
                </template>    
                <span>Saved</span>                
            </v-tooltip>
            <v-tooltip 
                top
                
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="red"                       
                        v-bind="attrs"
                        v-on="on"
                        v-show="error"
                    >
                        mdi-alert-circle
                    </v-icon>
                </template>    
                <span>Error</span>               
            </v-tooltip>
            <v-progress-circular
                indeterminate
                color="primary"
                v-show="saving"
                size="16"
                width="3"
            ></v-progress-circular>
        </td>
    </tr>

    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    props:{
        studentRecord: Object,
        formLevel: Number,        
    },
    created () {
        this.initialize();
    },  
    watch: {        
        codedComments: {
            deep: true,
            handler(value){
                if(value.length != 0){
                    this.setComments();
                }
            }
        },
        codedComment: {
            handler(value){
                this.markRecord.coded_comment = value.id;
            }
        },
        codedComment1: {
            handler(value){
                //(value);
                this.markRecord.coded_comment_1 = value.id;
            }
        },
       
    },       
    data() {
        return {
            commentsConduct: [],
            commentsApplication: [],
            commentsPreparedness: [],            
            comments1: [],
            comments2: [],            
            markRecord: {},
            codedComment: { id: null, comment: null },
            codedComment1: { id: null, comment: null },
            saved: false,
            saving: false,
            error: false,
            disableCodedComment: false,
            disableCodedComment1: false,
            disableExamMark: false,
            disableCourseMark: false,
            termTwo: false,
            grades: [
                { grade: '10', description: 'Excellent'},
                { grade: '9', description: 'Very Good'},
                { grade: '8', description: 'Good'},
                { grade: '7', description: 'Fair'},
                { grade: '6', description: 'Poor'},
                { grade: '5', description: 'Unsatisfactory'},
            ],
        }
    },
    computed: {
        ...mapGetters({
            codedComments: 'termReports/getCodedComments',
            employeeId: 'auth/getEmployeeId',
            marksEntered: 'termReports/getSubjectStudentsMarksEntered',
            lessonSelected: 'termReports/getLessonSelected',
            table2Records: 'termReports/getTable2Records',
            currentTerm: 'termReports/getCurrentTerm',
            commentSheet: 'termReports/getCommentSheetEnterMarks', 
        }),
       
    },
    methods : {
        ...mapMutations({
            setUpdatedRecord: 'termReports/setUpdatedTable2Record',
            setStudentSelected: 'termReports/setMarkSheetStudentSelected',
            setMarkSheetEntered: 'termReports/setSubjectStudentsMarksEntered',
            setCommentSheet: 'termReports/setCommentSheetEnterMarks',
            setSelectedTable2RecordIndex: 'termReports/setSelectedTable2RecordIndex',
        }),

        ...mapActions({
            save: 'termReports/saveTable2Record',
        }),
        
        initialize(){
            this.markRecord = {...this.studentRecord};
            this.setStudentSelected(null);
            this.savedDataCheck();
            this.setComments();
            this.setDisabledFields();
                       
        },

        async recordChanged(){
            if(this.recordBlankCheck()) return;
            

            this.saving = true;
            this.saved = false;
            this.error = false;

                
                
            this.setUpdatedRecord(
                {
                    "student_id" : this.markRecord.student_id,
                    "year" : this.markRecord.year,
                    "term" : this.markRecord.term,
                    "subject_id" : this.markRecord.subject_id,
                    "exam_mark" : this.markRecord.exam_mark,
                    "course_mark" : this.markRecord.course_mark,
                    "app1" : this.markRecord.app1,
                    "con1" : this.markRecord.con1,                   
                    "coded_comment" : this.codedComment.id,
                    "coded_comment_1" : this.codedComment1.id,
                    "employee_id" : this.employeeId,                   
                }
            );
                
            try {
                await this.save();
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error)
            }

            this.saving = false;
            this.saved = true;
            this.error = false;
            
                           
        },

        recordBlankCheck(){
            let record = [];
            let blank = true;                     
            record.push(this.markRecord.course_mark);
            record.push(this.markRecord.exam_mark);            
            record.push(this.codedComment.id);
            record.push(this.codedComment1.id);
            record.forEach(element => {
                if(element) blank = false;
            })
            return blank;
        },
        savedDataCheck(){
            if(!this.recordBlankCheck()) this.saved = true;
        },
        recordSelected(){
            let records = this.table2Records;
            let entered = 0;
            records.forEach(record => {
                if(record.course_mark || record.exam_mark || record.coded_comment || record.coded_comment_1){
                    entered++;
                }
            })
            console.log(entered);
            this.setStudentSelected(this.markRecord.name);
        },        
        setComments(){ 
            this.comments1.push({id: null, comment: null});  
            this.comments2.push({id: null, comment: null});
            this.codedComments.forEach(record =>{
                this.comments1.push({ id: record.id, comment: record.detail });
                this.comments2.push({ id: record.id, comment: record.detail });
            });           
            
            if(this.studentRecord.coded_comment){
                this.codedComment = { id: this.studentRecord.coded_comment };
            } 
            if(this.studentRecord.coded_comment_1){
                this.codedComment1 = { id: this.studentRecord.coded_comment_1 };
            }
            
        },
        setDisabledFields(){           
            console.log(`Setting disabled fields...`)
            if(this.currentTerm == 2 && this.formLevel <= 4){
                this.disableExamMark = true;            
            }
            
        },
        

        round (number, decimalPlaces) {            
            return Number(Math.round(number + "e" + decimalPlaces) + "e-" + decimalPlaces)
        },

        inputChanged () {
            console.log("input changed");
        }
    }
}
</script>

<style scoped> 
    ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details{
        padding: 0 6px;
    }

    /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    text-align:center
    }

    /* Firefox */
    ::v-deep input[type=number] {
    -moz-appearance: textfield;
    text-align: center;
    }
</style>